import Reveal from "@/components/site/Reveal";

export default function WhatIsIt() {
  return (
    <section
      data-testid="ateliers-what"
      className="py-24 md:py-32 bg-[#F3EEF4]"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — Définition
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 leading-[1.05]">
              Qu'est-ce qu'une constellation familiale&nbsp;?
            </h2>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <div className="relative p-10 md:p-12 bg-white rounded-3xl border border-[#DDD7E2] shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
              <span className="absolute -top-4 left-10 font-serif-display text-6xl text-[#C98FA3] leading-none select-none">
                «
              </span>
              <p className="text-lg md:text-xl text-[#1E1E2A] leading-relaxed font-serif-display">
                Une approche qui permet de représenter une situation à travers le groupe
                pour révéler les dynamiques invisibles.
              </p>
              <p className="mt-5 text-base text-[#5F6170] leading-relaxed">
                Sans interprétation prématurée, sans projection : ce qui apparaît est
                observé, accueilli, puis remis en mouvement dans un cadre posé.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
